import { render, staticRenderFns } from "./NlpSnowflake.vue?vue&type=template&id=4441fc3f"
import script from "./NlpSnowflake.vue?vue&type=script&lang=js"
export * from "./NlpSnowflake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports